var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhotoAlternate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4389_11623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 69.9533,
    height: 69.9533,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4389_11623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_photo_alternate_2",
    d: "M16.9053 57.42C15.6422 57.42 14.5978 57.0071 13.772 56.1813C12.9461 55.3554 12.5332 54.311 12.5332 53.0479V16.9054C12.5332 15.6423 12.9461 14.5979 13.772 13.7721C14.5978 12.9462 15.6422 12.5333 16.9053 12.5333H35.4138C35.7028 12.5333 35.9452 12.6314 36.141 12.8277C36.3363 13.0235 36.4339 13.2664 36.4339 13.5564C36.4339 13.8459 36.3363 14.0878 36.141 14.2821C35.9452 14.4764 35.7028 14.5736 35.4138 14.5736H16.9053C16.2252 14.5736 15.6665 14.7922 15.2293 15.2294C14.7921 15.6666 14.5735 16.2253 14.5735 16.9054V53.0479C14.5735 53.728 14.7921 54.2867 15.2293 54.7239C15.6665 55.1611 16.2252 55.3797 16.9053 55.3797H53.0478C53.7279 55.3797 54.2866 55.1611 54.7238 54.7239C55.161 54.2867 55.3796 53.728 55.3796 53.0479V34.5394C55.3796 34.2504 55.4777 34.008 55.674 33.8122C55.8698 33.6169 56.1127 33.5193 56.4027 33.5193C56.6922 33.5193 56.9341 33.6169 57.1284 33.8122C57.3228 34.008 57.4199 34.2504 57.4199 34.5394V53.0479C57.4199 54.311 57.007 55.3554 56.1812 56.1813C55.3553 57.0071 54.3109 57.42 53.0478 57.42H16.9053ZM20.403 47.2185H49.5502L40.5874 35.2681L31.8432 46.1255L26.2324 39.6402L20.403 47.2185ZM49.5502 20.403H44.7409C44.4518 20.403 44.2097 20.3049 44.0144 20.1087C43.8186 19.9129 43.7207 19.67 43.7207 19.38C43.7207 19.0905 43.8186 18.8485 44.0144 18.6542C44.2097 18.4599 44.4518 18.3627 44.7409 18.3627H49.5502V13.5535C49.5502 13.2644 49.6483 13.0222 49.8445 12.827C50.0403 12.6312 50.2832 12.5333 50.5732 12.5333C50.8628 12.5333 51.1047 12.6312 51.299 12.827C51.4933 13.0222 51.5905 13.2644 51.5905 13.5535V18.3627H56.3998C56.6888 18.3627 56.931 18.4609 57.1263 18.6571C57.322 18.8529 57.4199 19.0958 57.4199 19.3858C57.4199 19.6753 57.322 19.9173 57.1263 20.1116C56.931 20.3059 56.6888 20.403 56.3998 20.403H51.5905V25.2123C51.5905 25.5014 51.4923 25.7435 51.2961 25.9388C51.1003 26.1346 50.8574 26.2325 50.5674 26.2325C50.2779 26.2325 50.0359 26.1346 49.8416 25.9388C49.6473 25.7435 49.5502 25.5014 49.5502 25.2123V20.403Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoAlternate);
export default __webpack_public_path__ + "static/media/add_photo_alternate.aa48a3aee257ac1cf84989e989849ff7.svg";
export { ForwardRef as ReactComponent };